import { useCallback, useState } from 'react'

import { post } from '@/services/general/post'

export const useContractsPost = () => {
  const [isLoading, setIsLoading] = useState(false)

  const contractPost = useCallback(
    async ({ contractId, userId }: { contractId: string; userId: string }) => {
      try {
        setIsLoading(true)

        if (!contractId) {
          return {
            sucesso: false,
            conteudo: 'Número do contrato é obrigatório'
          }
        }

        const response = await post({
          contractId,
          idUsuario: userId
        })

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { contractPost, isLoading }
}
